import { useEffect, useState, useContext } from 'react';
import {
  TextField,
  Autocomplete,
  createFilterOptions,
} from '@mui/material';

import { getDatabase, push, ref, set } from "firebase/database";
import { AuthContext } from 'components';

const db = getDatabase();
let filter = createFilterOptions({
  matchFrom: 'start',
});

export const BrandField = (props) => {
  const { brand } = props // brand id
  const { accountId, brands, userCreatedBrands } = useContext(AuthContext);
  const [ value, setValue ] = useState((userCreatedBrands?.[brand]?.displayName) || (brands?.[brand]?.displayName) || "")

  useEffect(() => {
    // console.log('BrandField', value)
  }, [value])

  let sortByLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    } else if (a.label > b.label) {
      return 1;
    } else {
      return 0;
    }
  }
  
  const user_brands = userCreatedBrands && Object.keys(userCreatedBrands).map((e) => ({
    type: 'Personal',
    label: userCreatedBrands?.[e]?.displayName,
    id: e
  })).sort(sortByLabel) || []

  const all_brands = brands && Object.keys(brands).map((e) => ({
    type: 'All brands',
    label: brands?.[e]?.displayName,
    id: e
  })).sort(sortByLabel) || []

  return (
    <Autocomplete
      value={value}
      onChange={(event, value) => {
        if (!value) return

        // New user brand creation happens here
        if (value.create) {
          const regex = /"([^"]+)"/g;
          const matches = value.label.match(regex);

          if (matches) {
            const extractedText = matches.map(match => match.replace(/"/g, ''));
            value.label = extractedText[0].toUpperCase()
          }
          const brandsRef = ref(db, 'userCreatedBrands/' + accountId)
          let newBrand = push(brandsRef)
          set(newBrand, { displayName: value.label })
          value.id = newBrand.key
          setTimeout(() => {
            setValue(value.label)
            if (props.onChange) { props.onChange(value) }
          }, 1000)
        }

        if (props.onChange) { props.onChange(value) }
        setValue(value.label)
      }}
      isOptionEqualToValue={(option, value) => {
        return option.label === value
      }}
      groupBy={(option) => option.type}
      options={[...user_brands, ...all_brands]}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.label}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} variant="standard" label="Vendor/Brand" />}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;
        if (inputValue) {
          filtered.unshift({
            type: 'Create new',
            label: `Add "${inputValue}"`,
            create: true
          })
        }

        return filtered;
      }}
    />
  )
}